import { NormalizedFMSUnitInterface, TopicVersionsPayload, UnitInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/TopicVersions/TopicVersions.Controller.ts
export class TopicsVersionsAPI {
  static async getTopicVersions(orgId: number) {
    return APIService.Server.get<TopicVersionsPayload>(`/topics/org/${orgId}`);
  }
}
